// CD-5148. Turns a pasted list (typically a column of cells copied from Excel) into the comma-separated
// value a multi-value search field sends to the backend. Used by `InputTypesEnum.TextList`
// (`ImportListTextField`). Separators are new lines, tabs (several copied columns), commas and
// semicolons. Spaces are NOT separators — a postal code such as `SW1A 1AA` is one value.
export default class importListHelper {
  // Tooltip of a TextList search field, so every list field explains itself the same way.
  static ListFieldTooltip =
    'One or more — separate them with commas, or paste a column from Excel with the list button';

  // Splits, trims and de-duplicates the values in the text, keeping their first-seen order.
  static ParseImportList(text: string | null | undefined): string[] {
    if (!text) {
      return [];
    }
    const values = String(text)
      .split(/[\r\n\t,;]+/)
      .map((v) => v.trim())
      .filter((v) => v !== '');
    return Array.from(new Set(values));
  }

  // The field value for a list: the values joined with commas.
  static ToImportListValue(values: string[]): string {
    return values.join(',');
  }

  // The current field value laid out one value per line, to pre-fill the Import list box.
  static ToImportListText(value: string | null | undefined): string {
    return importListHelper.ParseImportList(value).join('\n');
  }

  // True when the pasted text is a list (more than one line or cell) rather than a single value.
  static IsMultiValuePaste(text: string | null | undefined): boolean {
    return !!text && /[\r\n\t]/.test(text.trim());
  }
}
